(function() {
	'use strict';
	angular.module('app.setup')
		.service('reportCardParamsService', reportCardParamsService);

	reportCardParamsService.$inject = ['$http', 'URLS', 'leanFilterService'];
	function reportCardParamsService($http, URLS, leanFilterService) {
		return {
			getData: getData,
			addReportCardParameter: addReportCardParameter,
			updateReportCardParameter: updateReportCardParameter,
			deleteReportCardParameter: deleteReportCardParameter
		};
		
		function getData() {
			var pageUrl = buildUrl();
			return $http.get(URLS.host + pageUrl)
				.then(getDataComplete)
				.catch(getDataFailed);
			
			function getDataComplete(response) {
				return response.data;
			}
			
			function getDataFailed(error) {
				return [];
			}
		}
		
		function buildUrl() {
			var factories = leanFilterService.getFactoryList();
			var url = String.format(URLS.reportCardParameters, factories);
			url = addFilterQueryParams(url);
			return url;
		}
		
		function addFilterQueryParams(url) {
			var filterQueryParam = leanFilterService.getQueryParam();
			var parts = url.split('?');
			var qParams = '';
			if (parts.length > 1) {
				qParams = '?' + parts[1];
			}
			for (var i = 0; i < filterQueryParam.length; i++) {
				qParams = appendQueryParam(qParams, filterQueryParam[i].key, filterQueryParam[i].value);
			}
			return parts[0] + qParams;
		}

		function addReportCardParameter(reportCardParameter, siteId) {
			var pageUrl = String.format(URLS.reportCardParameter, siteId || globalConfig.factory.id);
			return $http.post(URLS.host + pageUrl, reportCardParameter)
				.then(addReportCardParameterSuccess, handleError);

			function addReportCardParameterSuccess(response) {
				return 'Report card parameter created successfully';
			}
		}

		function updateReportCardParameter(reportCardParameter, lastModified, siteId) {
			var pageUrl = String.format(URLS.reportCardParameter, siteId || globalConfig.factory.id);
			return $http.put(URLS.host + pageUrl + '/' + reportCardParameter.ndx, reportCardParameter, {headers: {'If-Unmodified-Since': lastModified}})
				.then(updateReportCardParameterSuccess, handleError);

			function updateReportCardParameterSuccess(response) {
				return response;
			}
		}

		function deleteReportCardParameter(reportCardParameterNdx, siteId) {
			var pageUrl = String.format(URLS.reportCardParameter, siteId || globalConfig.factory.id);
			return $http.delete(URLS.host + pageUrl + '/' + reportCardParameterNdx)
				.then(deleteReportCardParameterSuccess, handleError);

			function deleteReportCardParameterSuccess(response) {
				return 'Report card parameter deleted successfully';
			}
		}

		function handleError (error) {
			if (error.status === 403) {
				return '';
			} else if (error.status === 412) {
				return error.data.error;
			}
			return 'Unknown server error';
		}
	}
})();